import { Link, Outlet, useLocation } from "react-router-dom";
import { Logo } from "./app/components/Logo";
import { detectLang, t } from "./i18n";

export function Layout() {
  const { pathname } = useLocation();
  const lang = detectLang(pathname);
  const i = t(lang);
  const prefix = lang === "ja" ? "/ja" : "";

  return (
    <div className="flex min-h-screen flex-col bg-paper text-ink">
      <header className="sticky top-0 z-10 border-b-2 border-ink bg-paper">
        <nav className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-4 py-2.5 sm:px-6">
          <Link to={prefix || "/"}>
            <Logo sub={i.tagline} />
          </Link>
          <div className="flex items-center gap-2 text-[13px] font-bold sm:gap-4">
            <Link
              to={lang === "ja" ? "/" : "/ja"}
              className="border border-ink px-1.5 font-mono text-[11px] leading-5 hover:bg-marker"
            >
              {lang === "ja" ? "EN" : "JP"}
            </Link>
            <Link to="/app" className="hidden underline-offset-4 hover:underline sm:inline">
              {i.dashboard}
            </Link>
            <a
              href="/auth/login"
              className="press border-2 border-ink bg-shu px-3 py-1.5 text-[13px] font-bold text-white hover:bg-shu-deep"
            >
              {i.getStarted}
            </a>
          </div>
        </nav>
      </header>

      <div className="flex-1">
        <Outlet />
      </div>

      <footer className="mt-12 border-t-4 border-double border-ink">
        <div className="mx-auto flex max-w-5xl flex-col gap-4 px-4 py-8 text-[12px] sm:flex-row sm:items-end sm:justify-between sm:px-6">
          <div>
            <Logo />
            <p className="mt-2 text-ink-3">{i.copyright}</p>
          </div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 font-bold text-ink-2">
            <Link to={`${prefix}/terms`} className="hover:text-shu">
              {i.terms}
            </Link>
            <Link to={`${prefix}/privacy`} className="hover:text-shu">
              {i.privacy}
            </Link>
            {lang === "ja" && (
              <Link to="/ja/tokushoho" className="hover:text-shu">
                特定商取引法に基づく表記
              </Link>
            )}
          </div>
        </div>
      </footer>
    </div>
  );
}
